import { IInventoryValue, IManufacturerInfo, ISalesData } from "../../api/manufacturer/ManufacturersApi";

const DAYS_OF_WEEK = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

export default class Manufacturer {
  onHold?: number;
  aREmail?: string;
  address1?: string;
  address2?: string;
  autoReorderDate?: number;
  autoUpdate?: boolean;
  city?: string;
  contactName?: string;
  createdDate?: number;
  creditLimit?: number;
  claimEmail?: string;
  currencyCode?: string;
  defaultLeadTime?: string;
  defaultMaxInventoryValue?: number;
  defaultMinimumOrder?: number;
  defaultWeeksOfStocking?: string;
  domain?: string;
  googleEmail?: string;
  manufacturerId?: string;
  name?: string;
  outstandingBalance?: number;
  partnerPortal?: string;
  pOEmail?: string;
  phone?: string;
  postalCode?: string;
  province?: string;
  publicName?: string;
  representativeEmail?: string;
  shopifyWebsite?: string;
  terms?: string
  website?: string;
  publicEmail?: string;
  defaultTaxGroup?: string;
  salesData?: SalesData;
  fiscalYearMonthStart?: number;

  public IsOnHold(): boolean {
    return this.onHold === 1;
  }

  public AvailableCredit(): number {
    return (this.creditLimit || 0) - (this.outstandingBalance || 0);
  }

  get reorderDay() {
    if (this.autoReorderDate !== undefined && this.autoReorderDate >= 0 && this.autoReorderDate < DAYS_OF_WEEK.length) {
      return DAYS_OF_WEEK[this.autoReorderDate];
    }
    return 'ASAP';
  }

  public static convertFrom(source: IManufacturerInfo): Manufacturer {
    const manufacturer = new Manufacturer();

    manufacturer.onHold = source.OnHold;
    manufacturer.aREmail = source.AREmail;
    manufacturer.address1 = source.Address1;
    manufacturer.address2 = source.Address2;
    manufacturer.autoReorderDate = source.AutoReorderDate;
    manufacturer.autoUpdate = source.AutoUpdate;
    manufacturer.city = source.City;
    manufacturer.contactName = source.ContactName;
    manufacturer.createdDate = source.CreationDate;
    manufacturer.creditLimit = source.CreditLimit;
    manufacturer.claimEmail = source.ClaimEmail;
    manufacturer.currencyCode = source.CurrencyCode;
    manufacturer.defaultLeadTime = source.DefaultLeadTime;
    manufacturer.defaultMaxInventoryValue = source.DefaultMaxInventoryValue;
    manufacturer.defaultMinimumOrder = source.DefaultMinimumOrder;
    manufacturer.defaultWeeksOfStocking = source.DefaultWeeksOfStocking;
    manufacturer.domain = source.Domain;
    manufacturer.googleEmail = source.GoogleEmail;
    manufacturer.manufacturerId = source.ManufacturerId;
    manufacturer.name = source.Name;
    manufacturer.outstandingBalance = source.OutstandingBalance;
    manufacturer.partnerPortal = source.PartnerPortal;
    manufacturer.pOEmail = source.POEmail;
    manufacturer.phone = source.Phone;
    manufacturer.postalCode = source.PostalCode;
    manufacturer.province = source.Province;
    manufacturer.publicName = source.PublicName;
    manufacturer.representativeEmail = source.RepresentativeEmail;
    manufacturer.shopifyWebsite = source.ShopifyWebsite;
    manufacturer.terms = source.Terms;
    manufacturer.website = source.Website;
    manufacturer.publicEmail = source.PublicEmail;
    manufacturer.defaultTaxGroup = source.DefaultTaxGroup;
    manufacturer.fiscalYearMonthStart = source.FiscalYearMonthStart - 1;

    if (source.SalesData)
      manufacturer.salesData = SalesData.convertFrom(source.SalesData);

    return manufacturer;
  }
}

export class InventoryValue {
  inventoryValue?: number;
  purchaseOrderValue?: number;
  salesOrderValue?: number;
  location?: string;
  category?: string;

  public static convertFrom(source: IInventoryValue): InventoryValue {
    const inventoryValue = new InventoryValue();

    inventoryValue.inventoryValue = source.InventoryValue;
    inventoryValue.purchaseOrderValue = source.PurchaseOrderValue;
    inventoryValue.salesOrderValue = source.SalesOrderValue;
    inventoryValue.location = source.Location;
    inventoryValue.category = source.Category;

    return inventoryValue;
  }
}

export class SalesData {
  salesLast3Months?: number;
  salesLast30Days?: number;
  salesYearToDay?: number;

  public static convertFrom(source: ISalesData): SalesData {
    const salesData = new SalesData();

    salesData.salesLast3Months = source.SalesLast3Months;
    salesData.salesLast30Days = source.SalesLast30Days;
    salesData.salesYearToDay = source.SalesYearToDay;

    return salesData;
  }
}
